import React from 'react';
import PropTypes from 'prop-types';

import './createdByFooter.css';

const CreatedByFooter = ({
    createdBy,
    href,
    logoSrc,
    payoff,
}) => {
    const content = (
        <React.Fragment>
            <span className="mi-created-by-label">
                {createdBy}
            </span>

            <span className="mi-created-by-logo-wrap">
                <img
                    className="mi-created-by-logo"
                    src={logoSrc}
                    alt="PaD"
                />
            </span>

            <span className="mi-created-by-payoff">
                {payoff}
            </span>
        </React.Fragment>
    );

    return (
        <footer className="mi-created-by-footer">
            {href ? (
                <a
                    className="mi-created-by-link"
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${createdBy} PaD`}
                >
                    {content}
                </a>
            ) : (
                <div className="mi-created-by-content">
                    {content}
                </div>
            )}
        </footer>
    );
};

CreatedByFooter.defaultProps = {
    createdBy: 'Created by',
    href: '',
    logoSrc: '/icons/pad-created-by.png',
    payoff: 'Soluzioni digitali\nper il tuo business',
};

CreatedByFooter.propTypes = {
    createdBy: PropTypes.string,
    href: PropTypes.string,
    logoSrc: PropTypes.string,
    payoff: PropTypes.string,
};

export default CreatedByFooter;